import { render } from "./ConfigPage.vue?vue&type=template&id=5a003a5b&scoped=true"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"

import "./ConfigPage.vue?vue&type=style&index=0&id=5a003a5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a003a5b"]])

export default __exports__